module.exports = __webpack_public_path__ + "media/img/pages/companies/etat-de-vaud-6d766530bb8bf76d988fc64c13cf6c98.png";